export interface FAQTopic {
  id: string | number;
  title: string;
  faqs: {
    question: string;
    answer: string;
  }[];
}

export interface FaqTopicsArgs {
  config: {
    title?: string;
  };
  data: FAQTopic[] | unknown;
}
